import { motion, useReducedMotion } from "framer-motion";
import { Check, Play, Lock, Sparkles } from "lucide-react";

const NODES = [
  { label: "AI & LLM foundations", state: "done" },
  { label: "ChatGPT, Claude & Gemini", state: "done" },
  { label: "Prompt engineering", state: "active" },
  { label: "AI image & video tools", state: "locked" },
  { label: "Automation & AI agents", state: "locked" },
  { label: "AI for your profession", state: "locked" },
  { label: "Ship a real AI project", state: "locked" },
];

const PCT = Math.round((NODES.filter((n) => n.state === "done").length / NODES.length) * 100);

export function HeroRoadmap() {
  const reduce = useReducedMotion();
  return (
    <div className="bg-card border border-border shadow-brutal p-5" data-testid="hero-roadmap">
      <div className="flex items-center justify-between mb-4">
        <span className="font-mono text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Your AI roadmap</span>
        <span className="font-mono text-[10px] font-bold uppercase bg-brand-lime border border-border px-1.5 py-0.5">{PCT}%</span>
      </div>

      <div className="relative pl-6">
        {/* drawing connector */}
        <motion.div
          className="absolute left-[9px] top-2 bottom-2 w-0.5 bg-foreground origin-top"
          initial={reduce ? false : { scaleY: 0 }}
          whileInView={reduce ? {} : { scaleY: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: "easeOut" }}
        />
        <div className="space-y-2.5">
          {NODES.map((n) => {
            const done = n.state === "done";
            const active = n.state === "active";
            return (
              <div key={n.label} className="relative flex items-center gap-3">
                <span
                  className={`absolute -left-6 grid place-items-center h-4 w-4 border border-border ${
                    done ? "bg-brand-lime" : active ? "bg-brand-pink" : "bg-secondary"
                  }`}
                />
                <div
                  className={`flex-1 flex items-center gap-2.5 border border-border px-3 py-2 ${
                    done ? "bg-brand-lime" : active ? "bg-background shadow-brutal-sm" : "bg-secondary"
                  }`}
                >
                  <span className={`grid place-items-center h-6 w-6 shrink-0 border border-border ${done ? "bg-foreground text-brand-lime" : active ? "bg-brand-pink text-white" : "bg-card text-foreground"}`}>
                    {done ? <Check className="h-3.5 w-3.5" /> : active ? <Play className="h-3 w-3 fill-current" /> : <Lock className="h-3 w-3" />}
                  </span>
                  <span className="font-heading font-bold text-sm truncate text-foreground">{n.label}</span>
                  {active && (
                    <motion.span
                      className="ml-auto font-mono text-[9px] font-bold uppercase bg-brand-pink text-white border border-border px-1.5"
                      animate={reduce ? {} : { scale: [1, 1.12, 1] }}
                      transition={{ repeat: Infinity, duration: 1.6 }}
                    >
                      You
                    </motion.span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mt-4 flex items-center gap-2 border-t border-dashed border-border pt-3">
        <Sparkles className="h-4 w-4 text-brand-cyber" />
        <span className="font-mono text-[10px] font-bold uppercase tracking-wide text-muted-foreground">Curated &amp; sequenced for you</span>
      </div>
    </div>
  );
}
